<template>
  <!-- ケアオーケストレータークライアント証明書 -->
  <div id="COSettingClientCertificateInternal">
    <div id="container-center">
      <coSettingNavi v-bind:pageid='"COSettingClientCertificateInternal"'></coSettingNavi>
      <settingCertificate />
      <div style="margin-top:10px;">
          <b-button class="backbutton is-primary" @click="back">戻る</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from "@/components/mock/philips/careorchestrator/SettingNaviBar";
import contents from "@/components/mock/philips/careorchestrator/setting/ClientCertificate";

export default {
  name: "COSettingClientCertificateInternal",
  methods: {
    back: function() {
      this.$router.push({ name: "COUploadCertificate" , params: { searchConditions: this.searchConditions }});
    },
  },
  data() {
    let careOrchestratorInstitutionId = this.$route.params["careOrchestratorInstitutionId"];
    let certificationFlag = this.$route.params["certificationFlag"];
    let searchConditions = this.$route.params["searchConditions"]
    return {
      careOrchestratorInstitutionId : careOrchestratorInstitutionId,
      certificationFlag: certificationFlag,
      searchConditions, searchConditions
    };
  },
  filters: {},
  components: {
    coSettingNavi: naviBar,
    settingCertificate: contents
  },
};
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/components/mock/philips/careorchestrator/COSettingClientCertificate.vue